import React from 'react'

const Manual_menu_modificadores_opciones = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Modificadores y Opciones de Modificadores
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear y gestionar Modificadores en el sistema, detallando su configuración y asociación a los ítems. Ayuda a personalizar pedidos, mejorar la gestión del menú y aumentar la satisfacción del cliente.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Modificadores_y_Opciones_de_Modificadores__HNZcCfcFS4GpJpl_7Kb_6Q?as=scrollable"
          className="scribe-iframe-general-16"
          width="100%"
          height="7400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_modificadores_opciones